import styled from '@emotion/styled';

const DEFAULT_BANNER_IMAGE =
  'https://cdn.shopify.com/s/files/1/0021/4889/2732/files/Collection_regular_Desktop_be0eae92-0939-46d8-9c81-d2b6f0f3839b.jpg?v=1636429182';

const BannerContainer = styled.div<{ $bgImage: string }>`
  position: relative;
  width: 100%;
  height: 135px;
  display: flex;
  align-items: center;
  background: url(${({ $bgImage }) => $bgImage}) center / cover no-repeat;
  margin-bottom: 10px;

  @media (max-width: 900px) {
    height: 80px;
    align-items: flex-start;
  }
`;

const BannerContent = styled.div`
  width: 100%;
  max-width: 1170px;
  margin: 0 auto;
  padding: 0 15px;

  @media (max-width: 900px) {
    padding: 12px 15px;
  }
`;

const BannerTitle = styled.h1`
  margin: 0 0 6px 0;
  font-weight: 700;
  text-align: left;
  color: #292929;
  font-size: 48px;
  line-height: 50px;

  @media (max-width: 900px) {
    font-size: 25px;
    line-height: 30px;
  }
`;

const BannerDescription = styled.p`
  margin: 0;
  font-weight: 700;
  text-align: left;
  color: #292929;
  font-size: 18px;
  line-height: 20px;

  @media (max-width: 900px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

interface TopBannerProps {
  readonly title?: string;
  readonly description?: string;
  readonly backgroundImage?: string;
}

export function TopBanner({
  title,
  description,
  backgroundImage = DEFAULT_BANNER_IMAGE,
}: TopBannerProps) {
  if (!title) return null;

  return (
    <BannerContainer $bgImage={backgroundImage}>
      <BannerContent>
        <BannerTitle>{title}</BannerTitle>
        {description && <BannerDescription>{description}</BannerDescription>}
      </BannerContent>
    </BannerContainer>
  );
}

export default TopBanner;
